import type { CSSProperties } from "react";
import type { RenderNodeBase } from "../../../util/src/layout-compiler/types.js";
import { intersectRenderClipRects } from "../../../util/src/layout-compiler/renderClip.js";
import { buildNodeClipPath } from "../display-editor/LayoutRenderer.js";

/**
 * Builds CSS clip-path styles for a compiled render node from its clip stack.
 */
export function getRenderNodeClipStyle(
  node: RenderNodeBase,
  scale: number,
): Pick<CSSProperties, "clipPath" | "WebkitClipPath"> {
  if (!node.clipRects?.length) {
    return {};
  }

  const clipRect = intersectRenderClipRects(node.clipRects);
  if (!clipRect) {
    const emptyClip = "polygon(0px 0px, 0px 0px, 0px 0px, 0px 0px)";
    return {
      clipPath: emptyClip,
      WebkitClipPath: emptyClip,
    };
  }

  const clipPath = buildNodeClipPath(
    {
      left: clipRect.x,
      top: clipRect.y,
      right: clipRect.x + clipRect.width,
      bottom: clipRect.y + clipRect.height,
    },
    node.x,
    node.y,
    node.width,
    node.height,
    scale,
    node.rotation,
  );

  return {
    clipPath,
    WebkitClipPath: clipPath,
  };
}
